import type { DialogProps } from '@mui/material'
import { withConditional, type ModalWithConditionalProps } from './hocs/withConditional'
import { type ModalWithHookedConditionalProps, withHookedConditional } from './hocs/withHookedConditional'
import { ModalHeader } from './components/ModalHeader/ModalHeader'
import { ModalFooter } from './components/ModalFooter/ModalFooter'
import { ModalContent } from './components/ModalContent/ModalContent'
import * as $ from './Modal.styled'

export interface ModalProps
  extends DialogProps,
    Pick<ModalWithHookedConditionalProps, '_onConditionalExited'>,
    Pick<ModalWithConditionalProps, '_onConditionalExited'>,
    $.ModalProps {
  onClose?: DialogProps['onClose']
}

export const Modal: Settle.FC<ModalProps> & {
  Header: typeof ModalHeader
  Footer: typeof ModalFooter
  Content: typeof ModalContent
  Paper: typeof $.ModalPaper
  withConditional: typeof withConditional
  withHookedConditional: typeof withHookedConditional
} = ({ size = 'm', placement, children, _onConditionalExited, PaperProps, TransitionProps, ...props }) => (
  <$.Modal
    fullWidth={true}
    placement={placement}
    // @ts-expect-error I SPENT TOO MUCH TIME TRYING
    PaperComponent={$.ModalPaper}
    PaperProps={{
      ...PaperProps,
      fullScreen: props.fullScreen,
      placement,
      size,
    }}
    transitionDuration={0}
    TransitionProps={{
      ...TransitionProps,
      onExited: (node) => {
        TransitionProps?.onExited?.(node)
        _onConditionalExited?.()
      },
    }}
    {...props}
  >
    {children}
  </$.Modal>
)

Modal.Header = ModalHeader
Modal.Footer = ModalFooter
Modal.Content = ModalContent
Modal.Paper = $.ModalPaper
Modal.withConditional = withConditional
Modal.withHookedConditional = withHookedConditional

export type { ModalWithConditionalProps, ModalWithHookedConditionalProps }
